export default __webpack_public_path__ + "static/media/faith.215abe17.png";